// @ts-nocheck
import React from "react";
import withStyles from '@mui/styles/withStyles';
import {
    DialogTitle as MuiDialogTitle,
    Typography
} from '@mui/material';

import {styles} from "./ModalStyles";
import {CloseButton} from "./CloseButton";

const MuiModalTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <CloseButton onClose={()=>onClose()}/>
            ) : null}
        </MuiDialogTitle>
    );
});

export const ModalTitle = ({children, id, onClose}) => {
    return (
        <MuiModalTitle id={id} onClose={onClose}>{children}</MuiModalTitle>
    );
};